// extracted by mini-css-extract-plugin
module.exports = {"button":"ManageGroupEventSessionsSection_button__JH7Gg","title":"ManageGroupEventSessionsSection_title__3zMfy","helperText":"ManageGroupEventSessionsSection_helperText__33CEB"};